'use client';
import { useInView } from 'react-intersection-observer';
import { ReactNode } from 'react';

interface LazyHydrateProps {
  children: ReactNode;
  placeholderHeight?: string; // optionnel pour éviter le CLS
}

export default function LazyHydrateOnScroll({ children, placeholderHeight = '300px' }: LazyHydrateProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '200px', // précharge avant que l'utilisateur voit
    threshold: 0.1
  });

  // Si pas encore visible → on affiche juste un placeholder
  if (!inView) {
    return <div ref={ref} style={{ minHeight: placeholderHeight }} />;
  }

  // Dès que c'est visible → hydrate le contenu
  return <div ref={ref}>{children}</div>;
}
